<ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>

@if (model().contentLoaded) {
  <div class="ft-section winners-podium-section">
    <div class="ft-container full">
      <div class="ft-section-header">
        <div class="ft-row">
          <div class="ft-col-60">
            <div class="ft-label">{{ 'flipto.account.WinnersPodium' | translate }}</div>

            @if (model().contestActive) {
              <div class="ft-summary">
                {{ 'flipto.account.ChooseWinnersMessage' | translate }}
                @if (canClose()) {
                  <span>{{ 'flipto.account.EndPhotoContestMessage' | translate }}
                    {{ 'flipto.account.EndPhotoContestContactAMMessage' | translate }}
                  </span>
                }
              </div>
            }
          </div>
          <div class="ft-section-actions ft-col-40">
            @if (!model().contestClosed && canClose()) {
              <div class="ft-btn ft-btn-outline-light btn"
                   [attr.disabled]="announceDisabled ? 'disabled' : null"
                   [style.pointer-events]="announceDisabled ? 'none' : null"
                   (click)="openEndContest()">
                {{ 'flipto.account.AnnounceWinners' | translate }}
              </div>
            }

            @if (model().contestClosed) {
              <div class="ft-interim-message">Winners announced
                <span class="ft-date">{{ formatDate(model().contest?.closeDate, 'MMM D, YYYY') }}</span>
              </div>
            }
            @if (!model().contestClosed && !canClose()) {
              <div class="ft-interim-message">
                {{ 'flipto.account.AnnounceWinnersAfter' | translate }}
                <span class="ft-date">{{ formatDate(model().contest?.votingEndDate, 'MMM D, YYYY') }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      @if (!isPodiumDefined()) {
        <div>{{ 'flipto.account.ThereAreNoGoalsForFinalists' | translate }}</div>
      }
      @if (isPodiumDefined()) {
        <div class="winners-podium podium-size-{{ getNumberOfPlaces() }}">
          <ft-podium-ng [podium]="model().podium" compareBy="@photoUUID" [isEditable]="false">
            <div class="winners clearfix">
              <ft-podium-slot-ng class="winner-slot first-place"
                                 [winner]="model().podium.first" [src]="azurePhoto(model().podium.first, 'small')"
                                 placeType="first" captionType="normal" />
              <ft-podium-slot-ng class="winner-slot second-place"
                                 [winner]="model().podium.second" [src]="azurePhoto(model().podium.second, 'small')"
                                 placeType="second" captionType="normal" />
              <ft-podium-slot-ng class="winner-slot third-place"
                                 [winner]="model().podium.third" [src]="azurePhoto(model().podium.third, 'small')"
                                 placeType="third" captionType="normal" />
            </div>
            <div class="runners">
              <!-- gapless @for: whitespace inside the block would emit text nodes between
                   the inline slots (preserveWhitespaces) — v1 ng-repeat clones had none. -->
              @for (runner of model().podium.runnerUps.items; track $index) {<ft-podium-slot-ng class="winner-slot runner-up"
                                   [winner]="runner" [src]="azurePhoto(runner, 'small')"
                                   placeType="runner" />}
            </div>
          </ft-podium-ng>
        </div>
      }
    </div>
  </div>
}

@if (model().contentLoaded) {
  <div class="ft-section contest-stories-list-section">
    <div class="ft-container">
      <!-- Convert this into ft-contexttabs-nav for v2 when we phase out v1 -->
      <div class="ft-section-header">
        <div class="ft-row">
          <div class="ft-col-left">
            <div class="ft-label">
              {{ model().totalFinalists }} {{ (model().totalFinalists === 1 ? 'flipto.account.Finalist' : 'flipto.account.Finalists') | translate }}
            </div>
          </div>
          @if (isFliptoStaff()) {
            <div class="ft-section-actions ft-col-right">
              @if (!model().contestClosed) {
                <div class="ft-btn ft-btn-outline-dark" (click)="openCleanContest()">
                  {{ 'flipto.account.sections.platform.photoAdvocacy.AntiCheat' | translate }}
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="ft-contexttab-view active">
        <div class="ft-row">
          @for (finalist of finalists; track finalist) {
            <div class="ft-col-33">
              <div class="ft-panel entry-photo"
                   (click)="openPodiumEditor(finalist)"
                   [ftBackgroundImage]="azurePhoto(finalist, 'small')">
                <div class="score count">{{ finalist['@score'] }}</div>
                <div class="photo-info winner" [ngClass]="winnerTypeClass(finalist)">
                  <ft-image-ng [src]="finalist['@profileImageUrl']" [profilePhoto]="true" />
                  <div class="ft-label"><i class="icon"></i>{{ winnerTypeLabel(finalist) }}</div>
                </div>
              </div>
            </div>
          }
          @if (model().hasMoreData) {
            <div class="infinitescroll-load-container">
              <button class="ft-btn ft-btn-outline-dark" (click)="loadNextPage()">
                {{ 'flipto.account.LoadMore' | translate }}
              </button>
            </div>
          }
        </div>

        @if (!finalists.length) {
          <div class="placeholder-panel">
            {{ 'flipto.account.ThereAreNoFinalists' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Step 1 inc 2: endContestConfirmation modal, native chrome rendered inline
     (the v1 controller is now native, so the body bindings live here). Trigger:
     the "Declare winners" announce button. done-visible=false (the chrome footer
     renders empty, matching v1); the ConcludeCampaign button lives in the body's
     own .modal-footer (closeContest). -->
@if (isEndContestOpen()) {
  <div id="endContestConfirmation">
    <ft-modal-chrome-ng headerText="Declare winners" [doneVisible]="false" (cancel)="isEndContestOpen.set(false)">
      @if (hasWinnersMissing()) {
        <div class="modal-panel">
          <span class="close-contest-warning">
            {{ 'flipto.account.EndContestMissingPlaces' | translate }} {{ model().missingWinners.join(', ') }}.
            <br />
            {{ 'flipto.account.EndContestMissingPlacesStillCanClose' | translate }}
          </span>
        </div>
      }
      <div class="modal-summary">
        {{ 'flipto.account.EndContestNotificationMessage' | translate }}
      </div>
      <div class="modal-footer">
        <button class="ft-btn ft-btn-plus-1 ft-btn-default" (click)="closeContest()">
          {{ 'flipto.account.ConcludeCampaign' | translate }}
        </button>
      </div>
    </ft-modal-chrome-ng>
  </div>
}

<!-- Step 1 inc 3: podiumEditor modal (native chrome size=lg + the INTERACTIVE
     ftSetWinner mini-podium). Opened by clicking a finalist (openPodiumEditor →
     loads PhotoContest.photo). No header-text on the chrome (the body has its own
     .modal-header); on-done=savePodium (Save), footer Cancel reverts model.podium
     to the pre-edit snapshot (native ft-snapshot). The mini-podium edits mutate
     model.podium IN PLACE (shared with the sheet podium), exactly as v1. -->
@if (isPodiumEditorOpen() && model().photo) {
  <div id="podiumEditor" class="curation-modal winner-modal">
    <ft-modal-chrome-ng
      size="lg"
      footerAlign="center"
      doneText="Save"
      [cancelVisible]="false"
      [footerCancelVisible]="true"
      (done)="savePodiumAndClose()"
      (cancel)="cancelPodiumEditor()"
    >
      <div class="modal-header">
        <div class="modal-heading">{{ 'flipto.account.FinalistRanking' | translate }}</div>
        <div class="modal-sub-heading">{{ model().photo | fullName }}</div>
      </div>

      <div class="content-pane">
        <div class="photo-content">
          <div class="guest-photo">
            <img class="img-responsive" [src]="azurePhoto(model().photo, 'small')" />
          </div>
        </div>
        <div class="caption-content">
          <div class="guest-caption">{{ model().photo.caption }}</div>
        </div>
      </div>

      <div class="ft-row">
        <div class="ft-col-50">
          <div class="content-pane">
            <div class="quote-content">
              @if (model().photo.isQuotePositive) {
                <div class="guest-quote">{{ model().photo.quote }}</div>
              }
            </div>

            <div class="guest-profile">
              <ft-image-ng [src]="model().photo.profilePhotoUrl"
                [profilePhoto]="true"
                [alwaysVisible]="true"
                [silhouetteClass]="model().photo.silhouetteClass"
               />
              <div class="guest-name">{{ model().photo | fullName }}</div>
              <ul class="guest-activity list-unstyled">
                @if (isGuestInfoVisible()) {
                  <li>Email: {{ model().photo.email }}</li>
                }
                @if (isGuestInfoVisible() && model().photo.reservationNumber) {
                  <li>
                    Reservation#: {{ model().photo.reservationNumber }}
                  </li>
                }
                @if (!isInvitee()) {
                  <li>
                    <span [innerHTML]="bookedRoomNightsLabel()"></span>
                    {{ formatDate(model().finalist['@checkinDate'], 'M/D/YYYY') }}
                  </li>
                }
                @if (isInvitee()) {
                  <li>
                    {{ 'flipto.account.platform.ContestInvitee' | translate }}
                    {{ formatDate(model().finalist['@createDate'], 'M/D/YYYY') }}
                  </li>
                }
                <li class="count">
                  <strong>{{ model().photo.score }} {{ 'flipto.account.Points' | translate }}</strong>
                </li>
                <li>
                  {{ 'flipto.account.Shared' | translate }} {{ model().photo.totalShares }}
                  {{ 'flipto.account.Times' | translate | lowercase }}
                </li>
                <li>
                  {{ model().photo.totalSignUps }} {{ 'flipto.account.FriendsSignedUp' | translate | lowercase }}.
                  {{ model().photo.totalOtherShares }} {{ 'flipto.account.FriendsShared' | translate | lowercase }}
                </li>
              </ul>
              @if (!isGuestInfoVisible() && hasPiiPermissions()) {
                <div style="margin-top: 5px;">
                  <a class="ft-btn ft-btn-outline-light" (click)="showGuestInfo()">
                    {{ 'flipto.account.ShowInfo' | translate: model().photo }}
                  </a>
                </div>
              }
              <div style="margin-top: 5px;">
                <a class="ft-btn ft-btn-outline-light" (click)="openAdvocatePage()">
                  {{ 'flipto.account.sections.platform.photoAdvocacy.ViewTimeline' | translate: model().photo }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="ft-col-50">
          <div class="curation-pane">
            <div class="curation-pane-header">
              <div class="contest-board-icon"></div>
              <div class="curation-pane-heading">Winners Podium</div>
              @if (!model().contestClosed) {
                <span>Rank this photo</span>
              }
            </div>
            @if (!!model().podium) {
              <div
                class="winners-podium-mini podium-size-{{ getNumberOfPlaces() }}"
                [style.pointer-events]="!isContestEditable() ? 'none' : null"
                [attr.disabled]="!isContestEditable() ? 'disabled' : null"
              >
                <ft-podium-ng #editorPodium [podium]="model().podium" compareBy="@photoUUID" [isEditable]="isContestEditable()">
                  <div class="winners clearfix">
                    <ft-podium-slot-ng class="winner-slot first-place"
                      [winner]="model().podium.first"
                      [src]="azurePhoto(model().podium.first, 'thumbnail')"
                      placeType="first"
                      captionType="small"
                      [setWinnerFinalist]="model().finalist"
                      [podiumRef]="editorPodium"
                     />
                    <ft-podium-slot-ng class="winner-slot second-place"
                      [winner]="model().podium.second"
                      [src]="azurePhoto(model().podium.second, 'thumbnail')"
                      placeType="second"
                      captionType="small"
                      [setWinnerFinalist]="model().finalist"
                      [podiumRef]="editorPodium"
                     />
                    <ft-podium-slot-ng class="winner-slot third-place"
                      [winner]="model().podium.third"
                      [src]="azurePhoto(model().podium.third, 'thumbnail')"
                      placeType="third"
                      captionType="small"
                      [setWinnerFinalist]="model().finalist"
                      [podiumRef]="editorPodium"
                     />
                  </div>
                  <div class="runners">
                    <!-- gapless @for — see the winners-podium runners loop above. -->
                    @for (runner of model().podium.runnerUps.items; track $index) {<ft-podium-slot-ng class="winner-slot runner-up"
                        [winner]="runner"
                        [src]="azurePhoto(runner, 'thumbnail')"
                        placeType="runner"
                        [setWinnerFinalist]="model().finalist"
                        [podiumRef]="editorPodium"
                        [runnerIndex]="$index"
                       />}
                  </div>
                </ft-podium-ng>
              </div>
            }
          </div>
        </div>
      </div>
    </ft-modal-chrome-ng>
  </div>
}

<!-- Step 1 inc 4: cleanContestConfirmation modal (staff-only anti-cheat). The body
     is the native ft-date-picker-ng (jQuery daterangepicker re-init). on-done=
     cleanContestCheaters ("Clean"); header + description + X close per v1 defaults. -->
@if (isCleanContestOpen()) {
  <div id="cleanContestConfirmation">
    <ft-modal-chrome-ng
      [headerText]="tr('flipto.account.sections.platform.photoAdvocacy.CleanUpContestCheaters')"
      [headerDescription]="tr('flipto.account.sections.platform.photoAdvocacy.AntiCheatWarning')"
      doneText="Clean"
      (done)="cleanContestAndClose()"
      (cancel)="isCleanContestOpen.set(false)"
    >
      <div class="modal-panel modal-panel-input">
        <ft-date-picker-ng [date]="model().cheaterCleanupCutoffDate"
          (dateChange)="model().cheaterCleanupCutoffDate = $event"
          position="left"
         />
      </div>
    </ft-modal-chrome-ng>
  </div>
}
